import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartWaterfallAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-waterfall-axis"} maskId="square-filled-radius-0-stroke-1-IconChartWaterfallAxis"><path d="M4 20H21V21H3V3H4V20Z" fill="currentColor"/><path d="M20 17H19V11H20V17Z" fill="currentColor"/><path d="M12 15H11V9H12V15Z" fill="currentColor"/><path d="M16 14H15V8H16V14Z" fill="currentColor"/><path d="M8 11H7V5H8V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChartWaterfallAxis;
